




























































import { Component, Prop, Emit, Mixins } from "vue-property-decorator"
import DatePicker from "@/components/DatePicker.vue"
import TimePicker from "@/components/TimePicker.vue"
import StatusMixin from "../mixins/status-mixin"
import FrontUrlMixin from "../mixins/front-url-mixins"

@Component({
  components: { DatePicker, TimePicker },
})
export default class PublishDate extends Mixins(StatusMixin, FrontUrlMixin) {
  @Prop()
  private articleId!: number
  @Prop()
  private publishedAt!: string
  @Prop()
  private endOfPublishedAt!: string
  @Prop()
  private status!: string
  @Prop()
  private readonly!: boolean

  @Emit("publishedAt")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitPublishedAt(datetime: string) {
    /** */
  }
  @Emit("endOfPublishedAt")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitEndOfPublishedAt(datetime: string) {
    /** */
  }

  private changePublishDate(newDate: string, label: string) {
    this.innerChangeDate(newDate, label)
  }

  private changeEndOfPublishDate(newDate: string, label: string) {
    this.innerChangeDate(newDate, label)
  }

  private innerChangeDate(newDate: string, label: string) {
    if (newDate !== "" && newDate !== null) {
      if (label === "公開日") {
        const time = this.publishTime ? this.publishTime : "00:00"
        this.emitPublishedAt(newDate + " " + time)
      } else if (label === "公開終了予定日") {
        const time = this.endOfPublishTime ? this.endOfPublishTime : "00:00"
        this.emitEndOfPublishedAt(newDate + " " + time)
      }
    } else {
      if (label === "公開日") {
        this.emitPublishedAt("")
      } else if (label === "公開終了予定日") {
        this.emitEndOfPublishedAt("")
      }
    }
  }

  private changePublishTime(newTime: string, label: string) {
    this.innerChangeTime(newTime, label)
  }

  private changeEndOfPublishTime(newTime: string, label: string) {
    this.innerChangeTime(newTime, label)
  }

  private innerChangeTime(newTime: string, label: string) {
    if (label === "公開日") {
      if (this.publishedAt !== "") {
        const oldDate = this.publishDate
        if (newTime !== "" && newTime !== null) {
          this.emitPublishedAt(oldDate + " " + newTime)
        } else {
          this.emitPublishedAt(oldDate + " " + "00:00")
        }
      }
    } else if (label === "公開終了予定日") {
      if (this.endOfPublishedAt !== "") {
        const oldDate = this.endOfPublishDate
        if (newTime !== "" && newTime !== null) {
          this.emitEndOfPublishedAt(oldDate + " " + newTime)
        } else {
          this.emitEndOfPublishedAt(oldDate + " " + "00:00")
        }
      }
    }
  }

  private innerDate(date: string): string {
    return date !== "" && date !== null && date !== undefined
      ? date.split(" ")[0]
      : ""
  }

  private innerTime(date: string): string {
    if (date !== "" && date !== null && date !== undefined) {
      const time = date.split(" ")[1]
      if (time !== "00:00:00") {
        return time
      } else {
        return ""
      }
    } else {
      return ""
    }
  }

  get publishDate(): string {
    return this.innerDate(this.publishedAt)
  }

  get endOfPublishDate(): string {
    return this.innerDate(this.endOfPublishedAt)
  }

  get publishTime(): string {
    return this.innerTime(this.publishedAt)
  }

  get endOfPublishTime(): string {
    return this.innerTime(this.endOfPublishedAt)
  }
}
